
export function TextMatchAnswerExitViewConstructor(services) {

  let joint = services.joint;

  return joint.shapes.html.AbstractElementView.extend({
    isElementEditable: false,
    isElementDeletable: false,

    angularTemplate: `
    <div layout="column">
      <span translate="{{elementData.label}}"></span>
    </div>
    `,
  })
}
